module.exports = __webpack_public_path__ + "static/media/Gilroy-Light-Italic.d654e779.woff";